import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'

export interface DashboardStats {
  overview: {
    totalLicenses: number
    activeLicenses: number
    totalTenants: number
    activeTenants: number
    monthlyRevenue: number
    revenueGrowth: number
  }
  activity: Array<{
    id: string
    type: 'license' | 'tenant' | 'invoice' | 'extension'
    action: string
    subject: string
    metadata?: any
    timestamp: string
  }>
  topTenants: Array<{
    id: number
    name: string
    usage: number
    usagePercent: number
  }>
}

export const useDashboardStats = () => {
  return useQuery({
    queryKey: ['dashboard-stats'],
    queryFn: async () => {
      const response = await api['get']<DashboardStats>('/api/dashboard/stats')
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Failed to fetch dashboard stats')
      }
      return response.data
    },
    refetchInterval: 30000, // Refresh every 30s
  })
}
